import { render, staticRenderFns } from "./SpaceSettingsGeneral.vue?vue&type=template&id=3b8a78d6&"
import script from "./SpaceSettingsGeneral.vue?vue&type=script&lang=js&"
export * from "./SpaceSettingsGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports